import { jsx as a } from "@emotion/react/jsx-runtime";
import m from "@mui/material/Typography";
import { forwardRef as y } from "react";
const t = y(({ children: r, ...o }, p) => /* @__PURE__ */ a(m, { ref: p, ...o, children: r }));
t.displayName = "Typography";
export {
  t as T
};
